import startCase from 'lodash/startCase';

import StringConstants from 'app/shared/constants';

const stringHelper = {
    capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    currentYear() {
        return new Date().getFullYear();
    },
    pluralize(num, singular, plural) {
        return `${num} ${num === 1 ? singular : plural}`;
    },
    getPageTitle(titleContent, brand) {
        const formattedBrand = StringConstants.FORMATTED_BRAND_NAMES_RENTAL[brand];
        return `${titleContent} | ${formattedBrand}`;
    },
    wrapText(text = '', maxCharacters) {
        return `${text.slice(0, maxCharacters)}${text.length >= maxCharacters ? '…' : ''}`;
    },
    getUrlQueryParams() {
        const query = window.location.search.substring(1);

        if (!query) {
            return false;
        }
        const queryString = {};
        const vars = query.split('&');
        let i;
        let pair;

        for (i = 0; i < vars.length; i++) {
            pair = vars[i].split('=');
            if (typeof queryString[pair[0]] === 'undefined') {
                queryString[pair[0]] = decodeURIComponent(pair[1]);
            } else if (typeof queryString[pair[0]] === 'string') {
                queryString[pair[0]] = [queryString[decodeURIComponent(pair[0])], decodeURIComponent(pair[1])];
            } else {
                queryString[pair[0]].push(decodeURIComponent(pair[1]));
            }
        }
        return queryString;
    },
    getCookieByName(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);

        if (parts.length === 2) {
            return parts
                .pop()
                .split(';')
                .shift();
        }
        return null;
    },
    stripDollarSign(value) {
        return value.replace(/\$/g, '');
    },
    sanitizeReactInput(string) {
        let parsed = '';

        // react cannot inject "{" gracefully in strings
        // e.g. <div>`${"{"}`</div> will break
        if (string) {
            parsed = string.replace(/\{|\}/g, '');
        }

        return parsed;
    },
    /**
     * startCaseRemoveSpace
     *
     * @param {string} string
     *
     * ex: foo bar
     * => FooBar
     */
    startCaseRemoveSpace(string) {
        return startCase(string).replace(/\s/g, '');
    },
};

export default stringHelper;
